import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import {
  WorkOrderItemTag,
  CreateWorkOrderItemTagRequest,
  UpdateWorkOrderItemTagRequest,
} from './WorkOrderItemTags.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/itemTags`;

export async function listWorkOrderItemTags(
  params?: PageRequest,
): Promise<PageResult<WorkOrderItemTag>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<WorkOrderItemTag>;
}

export async function createWorkOrderItemTag(
  obj: CreateWorkOrderItemTagRequest,
): Promise<WorkOrderItemTag> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as WorkOrderItemTag;
}

export async function updateWorkOrderItemTag(
  obj: UpdateWorkOrderItemTagRequest,
): Promise<WorkOrderItemTag> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as WorkOrderItemTag;
}

export async function deleteWorkOrderItemTag(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
